export { default } from './CircularProgress';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/CircularProgress/index.js
// module id = 197
// module chunks = 121